import styles from './webkua-tool-bar.module.scss';
import { Col, Row } from 'reactstrap';
import { TableFilters, TableProductsFilter, TableProductsFilterProps, TextField, iTableSwitch, RadioFilterOpts, ToggleButton, ToggleButtonGroup } from '@frontend-workspace/react-shared-lib';
import TableDateSelection from 'libs/react-shared-lib/src/lib/focusTable/table-date-selection/table-date-selection';
import { DateRange } from '@mui/x-date-pickers-pro/DateRangePicker';
import { capitalize, Icon, IconButton, InputAdornment } from '@mui/material';
import { t } from 'i18next';

/* eslint-disable-next-line */
export interface WebkuaToolBarProps {
  tableFilters?: iTableSwitch[],
  productsFilter?: TableProductsFilterProps,
  dateRange?: DateRange<Date>,
  supportFutureDates?: boolean,
  onSetDateRange?: (dateRange: DateRange<Date> | null) => void,
  onRefresh?: () => void,
  disableSearch?: boolean,
  quickFilter: string,
  setQuickFilter: (value: string) => void,
  customComponent?: React.ReactNode,
}

export function WebkuaToolBar(props: WebkuaToolBarProps) {
  const search = (e: any) => props.setQuickFilter(e.target.value);
  return (
    <Row>
      {props.tableFilters &&
        <Col xs="auto" className='d-flex align-self-end mb-3'>
          <TableFilters switches={props.tableFilters} />
        </Col>
      }
      {props.productsFilter &&
        <Col xs="auto" className='d-flex align-self-end mb-3'>
          <TableProductsFilter
            {...props.productsFilter}
          />
        </Col>
      }
      {props.customComponent &&
        <Col xs="auto" className='d-flex align-self-end mb-3'>
          {props.customComponent}
        </Col>
      }
      <Col className='d-flex align-self-end justify-content-end flex-wrap flex-sm-nowrap mb-3'>
        {props.dateRange &&
          <TableDateSelection
            dateRange={props.dateRange}
            onSetDateRange={props.onSetDateRange}
            supportFutureDates={props.supportFutureDates}
          />
        }
        {!props.disableSearch &&
          <TextField
            type="search"
            onChange={search}
            value={props.quickFilter}
            label={t("simpleTable.search")}
            sx={{ minWidth: 150 }}
            InputProps={{
              startAdornment:
                <InputAdornment position="start">
                  <Icon>search</Icon>
                </InputAdornment>
            }}
          />
        }
        {props.onRefresh &&
          <IconButton onClick={props.onRefresh} className='d-flex align-items-end align-self-end ms-1'>
            <Icon>refresh</Icon>
          </IconButton>
        }
      </Col>
    </Row>
  );
}

export default WebkuaToolBar;